import React from 'react';
import './AboutUs.css';
import HomePage from './components/HomePage';

const AboutUs = () => {
  const problemCards = [
    {
      icon: '🧾',
      title: 'Manual Order Handling',
      text: 'Paper slips, missed orders, and verbal communication often create confusion during busy hours.',
    },
    {
      icon: '⏱️',
      title: 'Long Waiting Time',
      text: 'Customers wait longer when orders are taken manually and passed between staff members.',
    },
    {
      icon: '🧮',
      title: 'Billing Mistakes',
      text: 'Manual billing increases the chances of wrong totals, missing items, and payment confusion.',
    },
    {
      icon: '📦',
      title: 'Stock Confusion',
      text: 'Without proper stock visibility, vendors face shortage, over-selling, and poor inventory control.',
    },
  ];

  const solutionCards = [
    {
      icon: '✅',
      title: 'QR Ordering',
      text: 'Customers scan the QR code, choose items, and place orders directly from their mobile phones.',
    },
    {
      icon: '📊',
      title: 'Smart Dashboard',
      text: 'Vendors can manage orders, billing, stock, delivery, customers, and reports from one dashboard.',
    },
    {
      icon: '😊',
      title: 'Better Customer Experience',
      text: 'Faster ordering, clear pricing, simple checkout, and live order tracking improve customer satisfaction.',
    },
    {
      icon: '🚀',
      title: 'Business Growth',
      text: 'A digital system helps vendors save time, reduce mistakes, and operate more professionally.',
    },
  ];

  const featureCards = [
    {
      icon: '▦',
      title: 'QR Based Ordering',
      text: 'Customers can scan a QR code and place dine-in, takeaway, pickup, or delivery orders instantly.',
    },
    {
      icon: '📈',
      title: 'Vendor Dashboard',
      text: 'A complete dashboard for real-time orders, billing, stock, khata book, reports, and customer records.',
    },
    {
      icon: '🍔',
      title: 'Fast Food Ready',
      text: 'Built for table ordering, KOT, kitchen flow, quick billing, takeaway, and home delivery.',
    },
    {
      icon: '🛒',
      title: 'Grocery Ready',
      text: 'Supports retail and wholesale grocery ordering, inventory, categories, customer records, and delivery.',
    },
    {
      icon: '👥',
      title: 'Customer Friendly',
      text: 'Simple mobile ordering experience without app download, login complications, or long waiting time.',
    },
    {
      icon: '💼',
      title: 'Business Management',
      text: 'Helps vendors manage daily operations with more control, better records, and a professional image.',
    },
  ];

  const howItWorks = [
    {
      step: '01',
      icon: '▦',
      title: 'Scan QR',
      text: 'Customers scan the QR code placed on the table, counter, package, or shop display.',
    },
    {
      step: '02',
      icon: '🛍️',
      title: 'Choose Items',
      text: 'They browse the menu or product list, select items, and add them to the cart.',
    },
    {
      step: '03',
      icon: '🧾',
      title: 'Place Order',
      text: 'Customer details, order mode, payment option, and final confirmation are completed.',
    },
    {
      step: '04',
      icon: '🔔',
      title: 'Vendor Receives Order',
      text: 'The order appears instantly on the vendor dashboard for preparation, billing, and delivery.',
    },
  ];

  const benefits = [
    {
      icon: '⚡',
      title: 'Faster Service',
      text: 'Reduce waiting time and serve more customers with a faster digital ordering flow.',
    },
    {
      icon: '🎯',
      title: 'Fewer Mistakes',
      text: 'Avoid wrong orders, missing items, and manual billing errors with direct customer input.',
    },
    {
      icon: '🧾',
      title: 'Better Billing',
      text: 'Manage bills, order records, payments, taxes, and reports in a more organized way.',
    },
    {
      icon: '🛡️',
      title: 'Simple Management',
      text: 'Easy-to-use system designed for everyday shop operations and vendor-friendly workflows.',
    },
  ];

  return (
    <div className="about-page">
      <HomePage />
      <section className="about-hero">
        <div className="about-hero-bg about-hero-bg-left" />
        <div className="about-hero-bg about-hero-bg-right" />

        <div className="about-container about-hero-grid">
          <div className="about-hero-content">
            <span className="about-badge">About Our Platform</span>

            <h1>
              We Help Local Vendors <span>Go Digital</span>
            </h1>

            <p className="about-hero-text">
              A smart QR ordering and vendor management platform built for fast food
              shops, grocery stores, retail vendors, and wholesale businesses. Manage
              dine-in orders, takeaway, home delivery, billing, stock, khata book, and
              customer records from one simple digital system.
            </p>

            <div className="about-hero-actions">
              <button className="about-primary-btn" type="button">
                Get Started
                <span>→</span>
              </button>

              <button className="about-secondary-btn" type="button">
                View Features
                <span>▦</span>
              </button>
            </div>

            <div className="about-trust-row">
              <div className="about-avatar-stack">
                <span>F</span>
                <span>G</span>
                <span>V</span>
              </div>

              <div>
                <strong>Built for local businesses</strong>
                <p>Fast food counters, grocery shops, retail stores, and delivery vendors.</p>
              </div>
            </div>
          </div>

          <div className="about-hero-visual">
            <div className="about-qr-card">
              <div className="about-mini-qr">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>
              <h3>Scan to Order</h3>
              <p>Table 7</p>
            </div>

            <div className="about-phone-mockup">
              <div className="about-phone-header">
                <div>
                  <strong>Tasty Bites</strong>
                  <span>Table 7</span>
                </div>
                <small>Dine-in</small>
              </div>

              <div className="about-phone-steps">
                <span className="active">Menu</span>
                <span>Cart</span>
                <span>Confirm</span>
                <span>Done</span>
              </div>

              <div className="about-phone-list">
                <div className="about-phone-item">
                  <div className="food-icon burger">🍔</div>
                  <div>
                    <strong>Veg Burger</strong>
                    <p>₹99</p>
                  </div>
                  <button type="button">+</button>
                </div>

                <div className="about-phone-item">
                  <div className="food-icon fries">🍟</div>
                  <div>
                    <strong>French Fries</strong>
                    <p>₹79</p>
                  </div>
                  <button type="button">+</button>
                </div>

                <div className="about-phone-item">
                  <div className="food-icon wrap">🌯</div>
                  <div>
                    <strong>Paneer Wrap</strong>
                    <p>₹119</p>
                  </div>
                  <button type="button">+</button>
                </div>

                <div className="about-phone-item">
                  <div className="food-icon coffee">🥤</div>
                  <div>
                    <strong>Cold Coffee</strong>
                    <p>₹89</p>
                  </div>
                  <button type="button">+</button>
                </div>
              </div>

              <div className="about-phone-cart">
                <span>View Cart • 2 Items</span>
                <strong>₹178</strong>
              </div>
            </div>

            <div className="about-flow-card">
              <div>
                <span>▦</span>
                <p>Scan QR</p>
              </div>

              <div>
                <span>🛍️</span>
                <p>Choose Items</p>
              </div>

              <div>
                <span>✅</span>
                <p>Place Order</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-problem-solution">
        <div className="about-container">
          <div className="about-section-heading">
            <span>Problem & Solution</span>
            <h2>Solving everyday problems for local vendors</h2>
            <p>
              Our platform turns manual order handling into a faster, smarter, and more
              professional digital workflow.
            </p>
          </div>

          <div className="about-compare-grid">
            <div className="about-compare-box problem">
              <h3>The Problem</h3>

              <div className="about-card-grid small">
                {problemCards.map((item) => (
                  <div className="about-mini-card" key={item.title}>
                    <div className="about-icon danger">{item.icon}</div>
                    <h4>{item.title}</h4>
                    <p>{item.text}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="about-compare-arrow">→</div>

            <div className="about-compare-box solution">
              <h3>Our Solution</h3>

              <div className="about-card-grid small">
                {solutionCards.map((item) => (
                  <div className="about-mini-card" key={item.title}>
                    <div className="about-icon success">{item.icon}</div>
                    <h4>{item.title}</h4>
                    <p>{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-features">
        <div className="about-container">
          <div className="about-section-heading">
            <span>One Platform</span>
            <h2>Everything you need to manage your shop digitally</h2>
            <p>
              From customer ordering to vendor operations, our system helps vendors
              manage business more smoothly.
            </p>
          </div>

          <div className="about-feature-grid">
            {featureCards.map((item) => (
              <div className="about-feature-card" key={item.title}>
                <div className="about-feature-icon">{item.icon}</div>
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-how">
        <div className="about-container">
          <div className="about-how-box">
            <div className="about-section-heading dark">
              <span>How It Works</span>
              <h2>A simple process with powerful results</h2>
            </div>

            <div className="about-how-grid">
              {howItWorks.map((item) => (
                <div className="about-how-step" key={item.step}>
                  <div className="about-step-number">{item.step}</div>
                  <div className="about-how-icon">{item.icon}</div>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="about-vendors">
        <div className="about-container about-vendor-grid">
          <div className="about-vendor-card fastfood">
            <div className="about-vendor-content">
              <span className="about-badge orange">For Fast Food Vendors</span>

              <h2>Built for speed. Designed for busy counters.</h2>

              <p>
                Perfect for fast food shops that need table ordering, takeaway orders,
                kitchen order tickets, billing, and delivery management in one system.
              </p>

              <ul>
                <li>Table QR ordering</li>
                <li>Kitchen order ticket flow</li>
                <li>Takeaway and delivery management</li>
                <li>Billing and order reports</li>
                <li>Delivery tracking support</li>
              </ul>
            </div>

            <div className="about-order-card">
              <div className="about-order-head">
                <strong>Current Orders</strong>
                <span>Table 4</span>
              </div>

              <div className="about-order-line">
                <span>🍔 Veg Burger</span>
                <strong>1 × ₹99</strong>
              </div>

              <div className="about-order-line">
                <span>🍟 French Fries</span>
                <strong>1 × ₹79</strong>
              </div>

              <div className="about-order-line">
                <span>🥤 Cold Coffee</span>
                <strong>1 × ₹89</strong>
              </div>

              <div className="about-order-total">
                <span>Total</span>
                <strong>₹267</strong>
              </div>

              <button type="button">Accept Order</button>
            </div>
          </div>

          <div className="about-vendor-card grocery">
            <div className="about-vendor-content">
              <span className="about-badge green">For Grocery Vendors</span>

              <h2>Manage stock. Sell more. Work smarter.</h2>

              <p>
                Designed for grocery stores, retail shops, and wholesale vendors who need
                better stock visibility, customer records, khata book, and delivery control.
              </p>

              <ul>
                <li>Retail and wholesale ordering</li>
                <li>Stock and inventory control</li>
                <li>Khata book and credit records</li>
                <li>Customer and supplier management</li>
                <li>Low stock alerts and delivery radius</li>
              </ul>
            </div>

            <div className="about-stock-card">
              <div className="about-stock-head">
                <strong>Stock Overview</strong>
                <span>Live</span>
              </div>

              {[
                { name: 'Tomato', qty: '120 kg', percent: 85 },
                { name: 'Potato', qty: '80 kg', percent: 65 },
                { name: 'Onion', qty: '60 kg', percent: 50 },
                { name: 'Rice 5kg', qty: '45 Pack', percent: 75 },
              ].map((item) => (
                <div className="about-stock-row" key={item.name}>
                  <div>
                    <span>{item.name}</span>
                    <strong>{item.qty}</strong>
                  </div>

                  <div className="about-stock-bar">
                    <span style={{ width: `${item.percent}%` }} />
                  </div>
                </div>
              ))}

              <div className="about-stock-total">
                <span>Total Items</span>
                <strong>250</strong>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-benefits">
        <div className="about-container">
          <div className="about-section-heading">
            <span>Why Choose Us</span>
            <h2>Why vendors choose our platform</h2>
            <p>
              We focus on simple technology that helps local businesses save time,
              reduce mistakes, and serve customers better.
            </p>
          </div>

          <div className="about-benefit-grid">
            {benefits.map((item) => (
              <div className="about-benefit-card" key={item.title}>
                <div className="about-benefit-icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-cta-section">
        <div className="about-container">
          <div className="about-cta-box">
            <div className="about-shop-visual">
              <div className="about-shop-roof" />

              <div className="about-shop-body">
                <div className="about-shop-door" />
                <div className="about-shop-window" />
              </div>

              <div className="about-shop-qr">
                <span />
                <span />
                <span />
                <span />
              </div>
            </div>

            <div className="about-cta-content">
              <h2>
                Ready to make your <span>shop digital?</span>
              </h2>

              <p>
                Start using smart QR ordering and manage your shop with a professional
                digital system built for local vendors.
              </p>

              <div className="about-cta-points">
                <span>✓ Easy Setup</span>
                <span>✓ Vendor Friendly</span>
                <span>✓ Secure & Reliable</span>
              </div>
            </div>

            <div className="about-cta-actions">
              <button className="about-primary-btn" type="button">
                Get Started Now
                <span>→</span>
              </button>

              <button className="about-outline-dark-btn" type="button">
                Book a Demo
              </button>
            </div>
          </div>
        </div>
      </section>

      <section
        className="about-support-section"
        style={{
          padding: '30px 20px 70px',
          background: '#f8fafc',
        }}
      >
        <div className="about-container">
          <div
            className="about-support-box"
            style={{
              maxWidth: '900px',
              margin: '0 auto',
              padding: '35px 40px',
              background: '#ffffff',
              borderRadius: '24px',
              display: 'flex',
              alignItems: 'center',
              gap: '25px',
              boxShadow: '0 12px 35px rgba(0, 0, 0, 0.08)',
              border: '1px solid #e8edf3',
              flexWrap: 'wrap',
            }}
          >
            <div
              className="about-support-icon"
              style={{
                width: '70px',
                height: '70px',
                minWidth: '70px',
                borderRadius: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '32px',
                background: '#eef4ff',
              }}
            >
              ✉️
            </div>

            <div
              className="about-support-content"
              style={{ flex: '1 1 280px' }}
            >
              <span
                style={{
                  color: '#2563eb',
                  fontSize: '14px',
                  fontWeight: '700',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Need Help?
              </span>

              <h2
                style={{
                  margin: '6px 0 8px',
                  fontSize: '28px',
                  color: '#111827',
                }}
              >
                Contact Us
              </h2>

              <p
                style={{
                  margin: '0 0 12px',
                  color: '#64748b',
                  lineHeight: '1.6',
                }}
              >
                Have a question or need help with VAKRA? Our support team is here to assist you.
              </p>

              <a
                href="mailto:support@vakra.co.in"
                style={{
                  display: 'inline-block',
                  color: '#2563eb',
                  fontSize: '18px',
                  fontWeight: '700',
                  textDecoration: 'none',
                  wordBreak: 'break-word',
                }}
              >
                support@vakra.co.in
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
